var utils = require('./utils');

const $infobox = $('.info-box');

function init(){
  bindEvents();
}

function bindEvents(){
  $(document).on(utils.clickEvent, '.btn-info', toggleInfo);
  $(document).on(utils.clickEvent, '.info-dark-overlay', toggleInfo);
  $(document).on(utils.clickEvent, '.info-box .close', toggleInfo);
  $(document).on(utils.clickEvent, '.scrolltop-button', scrolltop);
  $(document).on(utils.clickEvent, '.calltoaction', scrolldown);
  $(document).on('mousedown', '.photovrse-container', onMouseDown);
  $(document).on('mouseup', '.photovrse-container', onMouseUp);
}

function toggleInfo(evt){
  evt.preventDefault();
  evt.stopPropagation();

  $infobox.toggleClass('active');
  $('html').toggleClass('prevent-scrolling info-active');
}

function scrolltop(){
  $('html, body').animate({ scrollTop : 0 }, 600);
}

function scrolldown(){
  $('html, body').animate({ scrollTop : window.innerHeight }, 600);
}

function onMouseDown() {
  $(this).toggleClass('active', true);
}

function onMouseUp() {
  $(this).toggleClass('active', false);
}

module.exports = {
  init: init
}